import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Shield, AlertTriangle, Ban, Star, ChevronRight } from 'lucide-react';
import api from '../lib/api';

export default function Guidelines() {
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      try {
        const { data: d } = await api.get('/safety/guidelines');
        setData(d);
      } catch {}
      setLoading(false);
    };
    fetch();
  }, []);

  if (loading) return (
    <div className="content-area px-4 pt-4">
      {[1,2,3].map(i => <div key={i} className="skeleton h-20 rounded-2xl mb-3" />)}
    </div>
  );

  return (
    <div className="content-area animate-fade-in" data-testid="guidelines-page">
      <div className="px-4 pt-5 pb-3 flex items-center gap-3">
        <button onClick={() => navigate(-1)} data-testid="guidelines-back">
          <ArrowLeft size={22} className="text-[#111111]" />
        </button>
        <div>
          <h1 className="text-xl font-bold text-[#111111]">{data?.title}</h1>
          <p className="text-xs text-[#6B6E73]">{data?.subtitle}</p>
        </div>
      </div>

      <div className="px-4 pb-8 space-y-5">
        {/* Rules */}
        <div className="space-y-2">
          {data?.rules?.map(rule => (
            <div key={rule.id} className="bg-white rounded-2xl p-4 border border-black/[0.06] shadow-sm" data-testid={`rule-${rule.id}`}>
              <div className="flex items-start gap-3">
                <Shield size={18} className="text-[#B6E600] flex-shrink-0 mt-0.5" />
                <div>
                  <h3 className="text-sm font-bold text-[#111111]">{rule.title}</h3>
                  <p className="text-xs text-[#6B6E73] mt-1 leading-relaxed">{rule.desc}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Penalties */}
        <div>
          <h2 className="text-base font-bold text-[#111111] mb-3 px-1">Enforcement</h2>
          <div className="bg-white rounded-2xl border border-black/[0.06] overflow-hidden shadow-sm">
            {data?.penalties?.map((p, i) => (
              <div key={p.level} className={`flex items-center gap-3 p-4 ${i > 0 ? 'border-t border-black/[0.04]' : ''}`}>
                <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                  p.level === 1 ? 'bg-[#FF9500]/10' : p.level === 2 ? 'bg-[#FF3B30]/10' : 'bg-[#111]/10'
                }`}>
                  {p.level === 1 ? <AlertTriangle size={16} className="text-[#FF9500]" /> :
                   p.level === 2 ? <AlertTriangle size={16} className="text-[#FF3B30]" /> :
                   <Ban size={16} className="text-[#111111]" />}
                </div>
                <div className="flex-1">
                  <p className="text-sm font-semibold text-[#111111]">{p.action}</p>
                  <p className="text-[11px] text-[#6B6E73]">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Host Standards */}
        <div>
          <h2 className="text-base font-bold text-[#111111] mb-3 px-1 flex items-center gap-2">
            <Star size={16} className="text-[#B6E600]" /> {data?.host_standards?.title}
          </h2>
          <div className="bg-white rounded-2xl p-4 border border-black/[0.06] space-y-3 shadow-sm">
            {data?.host_standards?.rules?.map((rule, i) => (
              <div key={i} className="flex items-start gap-2.5">
                <div className="w-5 h-5 rounded-full bg-[#B6E600]/15 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <span className="text-[10px] font-bold text-[#3F5200]">{i + 1}</span>
                </div>
                <p className="text-xs text-[#111111] leading-relaxed">{rule}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
